import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../Color.js";
import { toCIMSymbolJSON as t, isCIMMarker as o, isCIMStroke as a, isCIMFill as r, isCIMMarkerStrokePlacement as c, fromCIMColor as s } from "../cim/utils.js";

function n(e) {
  var c = t(e);
  if ("CIMTextSymbol" === c.type) return c.height;
  var s = 0;

  if (c.symbolLayers) {
    var _iterator = _createForOfIteratorHelper(c.symbolLayers),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _t = _step.value;
        o(_t) && _t.size > s ? s = _t.size : a(_t) && _t.width > s ? s = _t.width : r(_t);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return s;
}

function i(e, o, a) {
  var r = t(e),
      c = n(e);
  if (0 === c) return void l(r, o);
  f(r, o / c, !1, a);
}

function l(e, t) {
  if ("CIMTextSymbol" !== e.type) {
    if (e.symbolLayers) {
      var _iterator2 = _createForOfIteratorHelper(e.symbolLayers),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _o = _step2.value;

          switch (_o.type) {
            case "CIMPictureMarker":
            case "CIMVectorMarker":
              _o.size = t;
              break;

            case "CIMPictureStroke":
            case "CIMSolidStroke":
              _o.width = t;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } else e.height = t;
}

function f(e, t, o, a) {
  if ("CIMTextSymbol" !== e.type) {
    if (o && e.effects) {
      var _iterator3 = _createForOfIteratorHelper(e.effects),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _o2 = _step3.value;
          y(_o2, t);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    if (e.symbolLayers) {
      var _iterator4 = _createForOfIteratorHelper(e.symbolLayers),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _o3 = _step4.value;

          switch (_o3.type) {
            case "CIMPictureMarker":
            case "CIMVectorMarker":
              m(_o3, t, a);
              break;

            case "CIMPictureStroke":
            case "CIMSolidStroke":
              null != a && a.preserveOutlineWidth || (_o3.width *= t);
              break;

            case "CIMPictureFill":
              _o3.height *= t, _o3.offsetX *= t, _o3.offsetY *= t;
              break;

            case "CIMHatchFill":
              f(_o3.lineSymbol, t, !0, _objectSpread(_objectSpread({}, a), {}, {
                preserveOutlineWidth: !1
              })), _o3.offsetX *= t, _o3.offsetY *= t, _o3.separation *= t;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  } else e.height *= t;
}

function m(e, t, o) {
  if (e.markerPlacement && M(e.markerPlacement, t), e.offsetX *= t, e.offsetY *= t, e.anchorPoint && "Absolute" === e.anchorPointUnits && (e.anchorPoint = {
    x: e.anchorPoint.x * t,
    y: e.anchorPoint.y * t
  }), e.size *= t, "CIMVectorMarker" === e.type && e.markerGraphics) {
    var _iterator5 = _createForOfIteratorHelper(e.markerGraphics),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var _a = _step5.value;
        e.scaleSymbolsProportionally || f(_a.symbol, t, !0, o);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }
}

function M(e, t) {
  switch (c(e) && (e.offset *= t), e.type) {
    case "CIMMarkerPlacementAlongLineRandomSize":
    case "CIMMarkerPlacementAlongLineSameSize":
      if (e.customEndingOffset *= t, e.offsetAlongLine *= t, e.placementTemplate && e.placementTemplate.length) {
        var _o4 = e.placementTemplate.map(function (e) {
          return e * t;
        });

        e.placementTemplate = _o4;
      }

      break;

    case "CIMMarkerPlacementAlongLineVariableSize":
      if (e.maxRandomOffset *= t, e.placementTemplate && e.placementTemplate.length) {
        var _o5 = e.placementTemplate.map(function (e) {
          return e * t;
        });

        e.placementTemplate = _o5;
      }

      break;

    case "CIMMarkerPlacementOnLine":
      e.startPointOffset *= t;
      break;

    case "CIMMarkerPlacementAtExtremities":
      e.offsetAlongLine *= t;
      break;

    case "CIMMarkerPlacementAtMeasuredUnits":
    case "CIMMarkerPlacementOnVertices":
      break;

    case "CIMMarkerPlacementAtRatioPositions":
      e.beginPosition *= t, e.endPosition *= t;
      break;

    case "CIMMarkerPlacementPolygonCenter":
      e.offsetX *= t, e.offsetY *= t;
      break;

    case "CIMMarkerPlacementInsidePolygon":
      e.offsetX *= t, e.offsetY *= t, e.stepX *= t, e.stepY *= t;
  }
}

function y(e, t) {
  switch (e.type) {
    case "CIMGeometricEffectArrow":
    case "CIMGeometricEffectDonut":
      e.width *= t;
      break;

    case "CIMGeometricEffectBuffer":
      e.size *= t;
      break;

    case "CIMGeometricEffectCut":
      e.beginCut *= t, e.endCut *= t, e.middleCut *= t;
      break;

    case "CIMGeometricEffectDashes":
      if (e.customEndingOffset *= t, e.offsetAlongLine *= t, e.dashTemplate && e.dashTemplate.length) {
        var _o6 = e.dashTemplate.map(function (e) {
          return e * t;
        });

        e.dashTemplate = _o6;
      }

      break;

    case "CIMGeometricEffectExtension":
    case "CIMGeometricEffectJog":
    case "CIMGeometricEffectRadial":
      e.length *= t;
      break;

    case "CIMGeometricEffectMove":
      e.offsetX *= t, e.offsetY *= t;
      break;

    case "CIMGeometricEffectOffset":
    case "CIMGeometricEffectOffsetTangent":
      e.offset *= t;
      break;

    case "CIMGeometricEffectRegularPolygon":
      e.radius *= t;
      break;

    case "CIMGeometricEffectTaperedPolygon":
      e.fromWidth *= t, e.length *= t, e.toWidth *= t;
      break;

    case "CIMGeometricEffectWave":
      e.amplitude *= t, e.period *= t;
  }
}

function C(o) {
  var a = [];
  return k(t(o), a), a.length ? new e(s(a[0])) : null;
}

function k(e, t) {
  var r;
  r = "CIMTextSymbol" === e.type ? e.symbol : e;
  var s = "CIMPolygonSymbol" === e.type;

  if (r.symbolLayers) {
    var _iterator6 = _createForOfIteratorHelper(r.symbolLayers),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var _n = _step6.value;
        if (!(_n.colorLocked || s && (a(_n) || o(_n) && _n.markerPlacement && c(_n.markerPlacement)))) switch (_n.type) {
          case "CIMPictureMarker":
          case "CIMPictureStroke":
          case "CIMPictureFill":
            break;

          case "CIMVectorMarker":
            _n.markerGraphics.forEach(function (e) {
              k(e.symbol, t);
            });

            break;

          case "CIMSolidStroke":
          case "CIMSolidFill":
            b(t, _n.color);
            break;

          case "CIMHatchFill":
            k(_n.lineSymbol, t);
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  }
}

function b(e, t) {
  var _iterator7 = _createForOfIteratorHelper(e),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var _o7 = _step7.value;
      if (_o7.join(".") === t.join(".")) return;
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  e.push(t);
}

function I(o, a) {
  a instanceof e || (a = new e(a));
  p(t(o), a);
}

function p(e, t) {
  var r;
  r = "CIMTextSymbol" === e.type ? e.symbol : e;
  var s = "CIMPolygonSymbol" === e.type;

  if (r.symbolLayers) {
    var _iterator8 = _createForOfIteratorHelper(r.symbolLayers),
        _step8;

    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var _n2 = _step8.value;
        if (_n2.colorLocked) continue;
        if (s && (a(_n2) || o(_n2) && _n2.markerPlacement && c(_n2.markerPlacement))) continue;

        var _e = t.toArray(0);

        switch (_n2.type) {
          case "CIMPictureMarker":
          case "CIMPictureStroke":
          case "CIMPictureFill":
            break;

          case "CIMVectorMarker":
            _n2.markerGraphics.forEach(function (e) {
              p(e.symbol, t);
            });

            break;

          case "CIMSolidStroke":
          case "CIMSolidFill":
            _n2.color = _e;
            break;

          case "CIMHatchFill":
            p(_n2.lineSymbol, t);
        }
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
  }
}

function u(e) {
  var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  var a = t(e);
  return "CIMTextSymbol" === a.type || "CIMPointSymbol" === a.type ? o && 0 !== a.angle ? 360 - a.angle : a.angle || 0 : 0;
}

function h(e, a) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var c = t(e);

  if (r && 0 !== a && (a = 360 - a), "CIMTextSymbol" !== c.type) {
    if ("CIMPointSymbol" === c.type && c.symbolLayers) {
      var _e2 = a - (c.angle || 0);

      var _iterator9 = _createForOfIteratorHelper(c.symbolLayers),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _t2 = _step9.value;

          if (o(_t2)) {
            var _o8 = _t2.rotation || 0;

            _t2.rotateClockwise ? _o8 -= _e2 : _o8 += _e2, _t2.rotation = _o8;
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      c.angle = a;
    }
  } else c.angle = a;
}

export { I as applyCIMSymbolColor, h as applyCIMSymbolRotation, C as getCIMSymbolColor, u as getCIMSymbolRotation, n as getCIMSymbolSize, m as scaleCIMMarker, i as scaleCIMSymbolTo };